/**
 * What a signed-in person sees when their account is in no workspace. Shown by
 * the home page; platform and system admins have no workspace by design and
 * are not sent here.
 */
export default function NoWorkspaceState({ onSignOut }: { onSignOut: () => void }) {
  return (
    <div className="max-w-xl mx-auto py-16 text-center">
      <h2 className="text-xl font-heading font-semibold text-[var(--text-pri)] mb-3">
        Your account isn't in a workspace yet
      </h2>
      <p className="text-base text-[var(--text-sec)] leading-relaxed mb-6">
        Everything in Priorities lives inside a workspace, and this account hasn't been added to one.
        If someone invited you, open their invite link again. Otherwise ask your workspace admin to send one.
      </p>
      <div className="flex items-center justify-center gap-3">
        <a
          href="mailto:hello@priorities.ai?subject=I%20can%27t%20find%20my%20workspace"
          className="inline-flex items-center px-4 py-2 text-sm font-medium bg-[var(--slate)] text-white hover:opacity-90 transition-opacity"
        >
          Contact support
        </a>
        <button
          type="button"
          onClick={onSignOut}
          className="inline-flex items-center px-4 py-2 text-sm font-medium border border-[var(--rule-bright)] text-[var(--text-sec)] hover:bg-[var(--hover-tint)] transition-colors"
        >
          Sign out
        </button>
      </div>
    </div>
  );
}
